import { useEffect } from "react";
import { useLocation, useNavigate, Navigate, Outlet } from "react-router-dom";

const RequireAuth = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const hasTokenExpired = () => {
      if (localStorage.expirationTime) {
        const currentTime = new Date().getTime();
        // const timeRemaining = localStorage.expirationTime - currentTime
        // console.log(`Time Remaining: ${timeRemaining}`)


        if (currentTime >= localStorage.expirationTime) {
          localStorage.removeItem("user");
          localStorage.removeItem("expirationTime");

          navigate("/login");
          clearInterval(tokenExpirationInterval);

          return null;
        }
      } else {
        clearInterval(tokenExpirationInterval);
      }
    };

    const tokenExpirationInterval = setInterval(() => {
      // console.log("Checking for token expiration...")
      hasTokenExpired();
    }, 5000);
  }, [navigate]);

  
  try {
    const user = JSON.parse(localStorage?.getItem("user"));
    if (!user || !user?.token) {
      window.onload();
      return <Navigate to="/login" state={{ from: location }} replace />;
    }
  } catch (error) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
};

export default RequireAuth;
